import { action } from "satcheljs";
import type { ActionMessage } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

// Legacy MyOutlook hooks that callers outside apps/personalos still reference.
// Nothing in apps/personalos handles them anymore.

/** @deprecated No-op; retained until callers are removed. */
export function onBriefingDraftReplySent(_itemId: string, _mailboxInfo: MailboxInfo, _briefingId?: string): void { }

/** @deprecated No-op; retained until callers are removed. */
export function showBriefingReplySendingToast(_composeId: string, _durationSeconds: number): void { }

/** @deprecated No-op; retained until callers are removed. */
export function onPersonalOsComposeCommitted(): void { }

/** @deprecated */
export interface OnBriefingReplySendUndoneActionMessage extends ActionMessage {
    composeId: string;
}

/* skip-unused-action -- Still subscribed to outside apps/personalos; remove with that orchestrator. */
/** @deprecated Never dispatched; retained until its subscriber outside apps/personalos is removed. */
export const onBriefingReplySendUndone: (composeId: string) => OnBriefingReplySendUndoneActionMessage = action("onBriefingReplySendUndone", (composeId: string) => ({
    composeId,
}));
